import { useState } from 'react';
import { Controller, Control, FieldValues, Path } from 'react-hook-form';
import { Input } from 'clad-ui';
import { CircleCheck, Warning } from 'clad-ui/icons';
import { styled } from '@linaria/react';
import theme from 'clad-ui/theme/chotot';
const {
  colors
} = theme;
interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label?: string;
}
type ValidateRules = 'length' | 'uppercase' | 'lowercase' | 'number';
const validateLength = (value: string) => !!value && value.length >= 8 && value.length <= 32;
const validateUppercase = (value: string) => !!value && /[A-Z]/.test(value);
const validateLowercase = (value: string) => !!value && /[a-z]/.test(value);
const validateNumber = (value: string) => !!value && /[0-9]/.test(value);
const SecurePasswordControl = <T extends FieldValues,>(props: Props<T>) => {
  const {
    control,
    name,
    label
  } = props;
  const [valid, setValid] = useState<Record<ValidateRules, boolean>>({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false
  });
  const [isFocus, setIsFocus] = useState(false);
  const setValidByRule = (rule: ValidateRules, value: boolean) => {
    setValid(prev => ({
      ...prev,
      [rule]: value
    }));
  };
  const validateAll = (value: string) => {
    setValidByRule('length', validateLength(value));
    setValidByRule('uppercase', validateUppercase(value));
    setValidByRule('lowercase', validateLowercase(value));
    setValidByRule('number', validateNumber(value));
  };
  const handleFocus = () => {
    setIsFocus(true);
  };
  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (event.target.parentNode === (event.relatedTarget as Element)?.parentNode) {
      const input = event.target as HTMLInputElement;
      setTimeout(() => {
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
      }, 150);
      return false;
    }
    (event.relatedTarget as HTMLButtonElement)?.click();
    setIsFocus(false);
  };
  return <Controller name={name} control={control} rules={{
    required: {
      value: true,
      message: 'Vui lòng nhập mật khẩu.'
    },
    validate: {
      length: value => validateLength(value),
      uppercase: value => validateUppercase(value),
      lowercase: value => validateLowercase(value),
      number: value => validateNumber(value)
    }
  }} render={({
    field: {
      ref,
      ...field
    },
    fieldState: {
      invalid,
      error
    }
  }) => <div>
          <Input {...field} type="password" label={label} showPassword helptext={!isFocus ? error?.message : ''} status={invalid ? 'error' : 'default'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
      field.onChange(e);
      validateAll(e.target.value);
    }} onFocus={handleFocus} onBlur={handleBlur} />
          {isFocus && <ErrorList>
              <Error error={!valid.length}>Giới hạn từ 8-32 ký tự.</Error>
              <Error error={!valid.uppercase}>Tối thiểu 01 ký tự IN HOA.</Error>
              <Error error={!valid.lowercase}>Tối thiểu 01 ký tự in thường.</Error>
              <Error error={!valid.number}>Tối thiểu 01 chữ số.</Error>
            </ErrorList>}
        </div>} />;
};
const Error = ({
  children,
  error = false
}: {
  children?: string;
  error?: boolean;
}) => <ErrorWrapper error={error}>
    {error ? <Warning /> : <CircleCheck />}
    {children}
  </ErrorWrapper>;
const _exp = /*#__PURE__*/() => ({
  error
}) => error ? colors.red500 : colors.green400;
const ErrorWrapper = /*#__PURE__*/styled('li')({
  name: "ErrorWrapper",
  class: "e1mm75es",
  propsAsIs: false,
  vars: {
    "e1mm75es-0": [_exp()]
  }
});
const ErrorList = /*#__PURE__*/styled('ul')({
  name: "ErrorList",
  class: "elrvxki",
  propsAsIs: false
});
export default SecurePasswordControl;

require("./SecurePasswordControl.linaria.module.css!=!../../../node_modules/.pnpm/@linaria+webpack5-loader@4.1.17_webpack@5.95.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./SecurePasswordControl.tsx");